<template>
  <div v-if="counts && counts.locationUnreadCount" class="-mr-1 px-2 py-1 bg-primary-600 text-white rounded-lg text-xs">
    {{ Number(counts.locationUnreadCount) }}
  </div>
</template>

<script setup lang="ts">
import { useCustomerMessageStore } from '~/stores/useCustomerMessageStore'

const customerMessageStore = useCustomerMessageStore()

const counts = computed(() => customerMessageStore.counts)

onMounted(() => {
  customerMessageStore.fetchCounts()
})
</script>
